module.exports = __webpack_public_path__ + "static/mobility-a676f1e81869a77af0b3f25e86506859.jpg";